export default "__VITE_PUBLIC_ASSET__7cd3f9c6__"